import type { IAllowedSizes } from "@Components/ImageLoader";
import type { PropsWithStyleX } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export interface IImageLoaderBlur extends PropsWithStyleX {
    src: string;
    alt?: string;
    size?: IAllowedSizes;
    sizeDirection?: "height" | "width";
}

export default function ImageLoaderBlur({ size, src, sizeDirection, styleX, ...props }: IImageLoaderBlur) {
    if (sizeDirection) {
        src += `?${sizeDirection === "height" ? "h" : "w"}=${size}`;
    }

    return <img {...stylex.props(styles.imageTag, styleX)} loading="lazy" {...props} src={src} />;
}

const styles = stylex.create({
    imageTag: {
        objectFit: "contain",
        height: "100%",
        width: "100%",
    },
});
